<template>
    <span v-if="isVisible()"><slot></slot>
    </span>
    
</template>

<script>

export default {
    name:'l-field',
    props: { fieldname:String, fields:Object },
    methods: {
        isVisible() {
            if(this.fields) {
                if(this.fields.visibility) {
                    const t = this.fields.visibility.find(x => x.name == this.fieldname);
                    if(t) 
                        return t.visible;
                }
                return true;
            }
            return false;
        },
     
    }
} 
</script>